import { Routes, Route } from "react-router-dom";
import Login from "./Login";
import Signup from "./Signup";
import Home from "./HomePage";
import ProfilePage from "./ProfilePage";
import GoogleSuccess from "./GoogleSuccess";
import Navbar from "./components/Navbar/Navbar";
import { Outlet } from "react-router-dom";
import Resume from "./Resume";
import './App.css'
import NetworkPage from "./NetworkPage";
import JobPage from "./JobPage";
import MessagingPage from "./MessagingPage";
import NotificationPage from "./NotificationPage";
import Connections from "./Connections";
import ConnectionProfile from "./ConnectionProfile";
function App() {
  return (
    <Routes>
      <Route path="/" element={<Login />} />
      <Route path="/signup" element={<Signup />} />
      <Route path="/google-success" element={<GoogleSuccess />} />
      <Route element={<LayoutWithNavbar />}>
        <Route path="/home" element={<Home />} />
        <Route path="/connections" element={<Connections />} />
        <Route path="/connections/:userid" element={<ConnectionProfile />} />
        <Route path="/profile/:userid" element={<ProfilePage />} />
        <Route path="/resume/:userid" element={<Resume />} />
        <Route path="/network" element={<NetworkPage />} />
        <Route path="/jobs" element={<JobPage />} />
        <Route path="/messages" element={<MessagingPage />} />
        <Route path="/notification" element={<NotificationPage />} />
      </Route>
    </Routes>
  );
}
function LayoutWithNavbar() {
  return (
    <>
      <Navbar />
      <Outlet />
    </>
  );
}
export default App;